import Signup01 from '../components/signuppage/Signup01';

const Signup01Page = () => {
    return (
        <>
            <Signup01 />
        </>
    );
};

export default Signup01Page;
